import { Breadcrumbs, BreadcrumbsProps } from '../../Breadcrumbs'

export function CategoryBreadcrumb(props: BreadcrumbsProps) {
  const { category } = props

  return <Breadcrumbs category={category} />
}
